<button type="submit" class="btn btn-primary btn-lg col-md-12 col-xs-12 round-button font-mont-regular double-white"
    (click)="onClick();">
    <div>Replicate App.</div>
    <div>w/ New Vendor</div>
</button>
<div class="modal fade" id="{{modalId}}" tabindex="-1" role="dialog" aria-labelledby="reSubmitModal"
    data-keyboard="false" data-backdrop="static" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg w900" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <img src="/assets/images/icons/close_b.svg" />
                    CLOSE WINDOW
                </button>
            </div>
            <div class="modal-body">
                <h5 class="modal-title w-100 text-left font-mont-bold" id="exampleModalLongTitle">
                    <img src="/assets/images/icons/calculator.svg" />
                    Replicate App. w/ New Vendor
                </h5>
                <form [formGroup]="resubmitForm" (ngSubmit)="onSubmit();">
                    <div class="row">
                        <div class="col-12">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-container">
                                        <div class="form-title">
                                            Select the vendor/sales person to replicate app.
                                        </div>
                                        <div class="form-row">
                                            <div class="form-group col-6">
                                                <input type="text" formControlName="vendor" class="form-control"
                                                    id="vendor" name="vendor" (keyup)="onVendorNameKeyUp(0, 8)"
                                                    placeholder="Search Vendor Name">
                                            </div>
                                            <div class="form-group col-6">
                                                <input type="text" formControlName="salesperson" class="form-control"
                                                    id="salesperson" name="salesperson"
                                                    (keyup)="onSalespersonNameKeyUp(0, 8)"
                                                    placeholder="Search Salesperson Name">
                                            </div>
                                        </div>
                                        <div class="form-row">
                                            <div class="form-group col-6">
                                                <table>
                                                    <tbody>
                                                        <tr *ngFor="let vendor of vendorData.records">
                                                            <td (click)="onVendorClick(vendor);"
                                                                [ngClass]="{'selected':vendorSelected.id == vendor.id}">
                                                                {{vendor.name}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <ul class="pagination justify-content-end" *ngIf="vTotalPages > 1">
                                                    <li class="page-item" [ngClass]="{'disabled': vSliceNumber == 0}"
                                                        (click)="onVBackClick();">
                                                        <a class="page-link prev" tabindex="-1"><img
                                                                src="/assets/images/icons/prev.svg" /></a>
                                                    </li>
                                                    <li class="page-item" *ngFor="let slice of vSlices"
                                                        [ngClass]="{'active': vSliceNumber + 1 == slice}"
                                                        (click)="onVSliceClick(slice - 1);">
                                                        <a class="page-link"
                                                            *ngIf="slice - 1 > vSliceNumber - 5 && vSliceNumber + 5 > slice - 1">{{slice}}</a>
                                                    </li>
                                                    <li class="page-item"
                                                        [ngClass]="{'disabled': vSliceNumber == vTotalPages - 1}"
                                                        (click)="onVNextClick();">
                                                        <a class="page-link next"><img
                                                                src="/assets/images/icons/next.svg" /></a>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="form-group col-6">
                                                <table>
                                                    <tbody>
                                                        <tr *ngFor="let salesperson of salespeopleData">
                                                            <td (click)="onSalespersonClick(salesperson);"
                                                                [ngClass]="{'selected':salespersonSelected.id == salesperson.id}">
                                                                {{salesperson.name}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <ul class="pagination justify-content-end" *ngIf="sTotalPages > 1">
                                                    <li class="page-item" [ngClass]="{'disabled': sSliceNumber == 0}"
                                                        (click)="onSBackClick();">
                                                        <a class="page-link prev" tabindex="-1"><img
                                                                src="/assets/images/icons/prev.svg" /></a>
                                                    </li>
                                                    <li class="page-item" *ngFor="let slice of sSlices"
                                                        [ngClass]="{'active': sSliceNumber + 1 == slice}"
                                                        (click)="onSSliceClick(slice - 1);">
                                                        <a class="page-link"
                                                            *ngIf="slice - 1 > sSliceNumber - 5 && sSliceNumber + 5 > slice - 1">{{slice}}</a>
                                                    </li>
                                                    <li class="page-item"
                                                        [ngClass]="{'disabled': sSliceNumber == sTotalPages - 1}"
                                                        (click)="onSNextClick();">
                                                        <a class="page-link next"><img
                                                                src="/assets/images/icons/next.svg" /></a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="form-row">
                                            <div class="form-group col-6">
                                                <div>
                                                    Selected vendor: {{vendorSelected.name}}
                                                </div>
                                            </div>
                                            <div class="form-group col-6">
                                                <div>
                                                    Selected Salesperson: {{salespersonSelected.name}}
                                                </div>
                                            </div>
                                        </div>
                                        <button type="submit" [disabled]="!vendorSelected.id || !salespersonSelected.id"
                                            class="btn btn-primary btn-lg col-md-12 col-xs-12 round-button font-mont-regular float-right">
                                            REPLICATE APP
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
<app-error-dialog [modalId]="modalIdE" [title]="errorTitle" [messageA]="errorMessageA" [messageB]="errorMessageB"
    [messageC]="errorMessageC" [messageBClass]="errorMessageBClass" [dialogClass]="dialogClass">
</app-error-dialog>